export default [
  { key: 'requisitionerName' },
  { key: 'requisitionerPhone', type: 'tel' },
  { key: 'requisitionerEmail', type: 'email' },
]
